// The mis-tap catch (round 28, from ZT batch 6).
//
// A picked machine reads back as a card — identifier, name, rego, kind and
// type — because the moment to notice you tapped EX-04 instead of EX-05 is
// BEFORE twenty questions are answered against the wrong machine. After the
// draft exists the same card renders from the snapshot, which is what the
// signed record will say whatever the machine is later renamed to.
import type { ResourceSnapshot, TemplateAsset } from '../../formsApi';

const KIND_LABEL: Record<string, string> = {
  plant: 'Plant',
  vehicle: 'Vehicle',
};

/** Either source, one card: the picker's option row, or the frozen snapshot. */
export function MachineCard({
  machine,
}: {
  machine:
    | Pick<TemplateAsset, 'name' | 'identifier' | 'registrationNumber' | 'kind' | 'machineTypeName'>
    | null;
}) {
  if (!machine) return null;

  const typeLine = [KIND_LABEL[machine.kind] ?? machine.kind, machine.machineTypeName]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-3">
      <div className="text-sm font-medium text-gray-900">
        {machine.identifier ? `${machine.identifier} · ${machine.name}` : machine.name}
      </div>
      <div className="text-sm text-gray-600">
        {machine.registrationNumber ? `Rego ${machine.registrationNumber} · ` : ''}
        {typeLine}
      </div>
    </div>
  );
}

/** The snapshot, reshaped to the card's fields. */
export function machineFromSnapshot(snapshot: ResourceSnapshot | null) {
  if (!snapshot) return null;
  return {
    name: snapshot.name,
    identifier: snapshot.identifier,
    registrationNumber: snapshot.registrationNumber,
    kind: snapshot.kind,
    machineTypeName: snapshot.machineType,
  };
}
